import { DownloadCsvButton } from "../../../components/DownloadCsvButton";
import DateRangeSelector from "../../../components/DateRangeSelector";
import { CardContent, FormControl, MenuItem, Select, Stack } from "@mui/material";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export default function MeteringFiltersWithCsvCard({
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    energyType,
    setEnergyType,
    dataAgg,
    setDataAgg,
    portfolioView,
    energyData
}) {
    const { t } = useTranslation();

    const dataForCsv = useMemo(() => {
        if (!energyData || !energyData.categories) return [];
        const columnName = portfolioView ? "facility" : dataAgg;
        let arrayOfObjects = energyData.categories.map((c) => {
            return {
                [columnName]: c,
                consumption_kwh: energyData.consumption_kwh?.[c] ? energyData.consumption_kwh[c].reduce((acc, val) => acc + val, 0.0) : null,
                cost: energyData.cost?.[c] ? energyData.cost[c].reduce((acc, val) => acc + val, 0.0) : null,
                co2_kg: energyData.co2_kg?.[c] ? energyData.co2_kg[c].reduce((acc, val) => acc + val, 0.0) : null,
                date_from: fromDate.toISOString().split("T")[0],
                date_to: toDate.toISOString().split("T")[0],
            }
        })

        return arrayOfObjects;
    }, [energyData, fromDate, toDate, energyType, dataAgg, portfolioView])

    return (<Card>
        <CardContent>
            <Stack
                direction={{ sm: "column", md: "row" }}
                spacing={2}
            >
                <DateRangeSelector
                    fromDate={fromDate}
                    toDate={toDate}
                    onFromDateChange={(newDate) => setFromDate(newDate)}
                    onToDateChange={(newDate) => setToDate(newDate)}
                    small={true}
                    hideTitle
                />
                <FormControl
                    sx={{ minWidth: 170 }}
                    size="small"
                >
                    <Select
                        value={energyType}
                        onChange={(event) => setEnergyType(event.target.value)}
                    >
                        <MenuItem value="both">{t("Electricity & Gas")}</MenuItem>
                        <MenuItem value="electricity">{t("Electricity")}</MenuItem>
                        <MenuItem value="gas">{t("Gas")}</MenuItem>
                    </Select>
                </FormControl>
                {!portfolioView &&
                    <FormControl
                        sx={{ minWidth: 170 }}
                        size="small"
                    >
                        <Select
                            value={dataAgg}
                            onChange={(event) => setDataAgg(event.target.value)}
                        >
                            <MenuItem value="location">{t("By location")}</MenuItem>
                            <MenuItem value="system">{t("By system")}</MenuItem>
                        </Select>
                    </FormControl>
                }
                <DownloadCsvButton arrayOfObjectsData={dataForCsv} filename={`metering_data_${fromDate.toISOString().split("T")[0]}_${toDate.toISOString().split("T")[0]}.csv`} buttonText={t("Download CSV")} />
            </Stack>
        </CardContent>
    </Card>)
}